import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import {
  FiBook,
  FiCompass,
  FiCpu,
  FiImage,
  FiShoppingBag,
  FiFileText,
  FiEdit3,
  FiGlobe,
  FiMenu,
  FiX,
  FiTag,
  FiVideo,
  FiSettings,
  FiDollarSign,
} from "react-icons/fi";

const GuideLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const location = useLocation();

  // Close sidebar on mobile when route changes
  React.useEffect(() => {
    setIsSidebarOpen(false);
  }, [location]);

  const guideGroups = [
    {
      title: "Bắt đầu",
      items: [
        {
          path: "/guide/start-here",
          name: "Bắt đầu nhanh",
          icon: <FiCompass />,
        },
        {
          path: "/guide/manage-automations",
          name: "Quản lý automation",
          icon: <FiSettings />,
        },
      ],
    },
    {
      title: "Tự động đăng",
      items: [
        {
          path: "/guide/auto-post",
          name: "Từ chủ đề / WooCommerce",
          icon: <FiCpu />,
        },
        {
          path: "/guide/add-list-images",
          name: "Từ ảnh hoặc video",
          icon: <FiImage />,
        },
        {
          path: "/guide/product-auto-post",
          name: "Từ sản phẩm AutoWork",
          icon: <FiShoppingBag />,
        },
        {
          path: "/guide/manual-post",
          name: "Từ bài viết có sẵn",
          icon: <FiFileText />,
        },
      ],
    },
    {
      title: "Tạo nội dung",
      items: [
        {
          path: "/guide/normal-post",
          name: "Bài AI từ chủ đề",
          icon: <FiEdit3 />,
        },
        {
          path: "/guide/photos-post",
          name: "Bài AI từ ảnh/video",
          icon: <FiImage />,
        },
        {
          path: "/guide/website-post",
          name: "Bài WordPress",
          icon: <FiGlobe />,
        },
        {
          path: "/guide/classified-ad",
          name: "Tin rao vặt",
          icon: <FiTag />,
        },
        {
          path: "/guide/video-creator",
          name: "Video AI",
          icon: <FiVideo />,
        },
      ],
    },
    {
      title: "Khác",
      items: [
        {
          path: "/guide/affiliate",
          name: "Affiliate",
          icon: <FiDollarSign />,
        },
      ],
    },
  ];

  return (
    <div className="mt-[72px] flex min-h-[calc(100vh-72px)] bg-gray-50">
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed md:relative z-30 w-64 h-full bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 overflow-y-auto`}
      >
        <div className="p-4 border-b border-gray-100 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <FiBook className="text-blue-600" />
            Hướng dẫn
          </h2>
          <button
            className="md:hidden text-gray-500"
            onClick={() => setIsSidebarOpen(false)}
          >
            <FiX size={24} />
          </button>
        </div>
        <nav className="p-2 space-y-4">
          {guideGroups.map((group) => (
            <div key={group.title}>
              <div className="px-4 pb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                {group.title}
              </div>
              <div className="space-y-1">
                {group.items.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                        isActive
                          ? "bg-blue-50 text-blue-700"
                          : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                      }`
                    }
                  >
                    {item.icon}
                    {item.name}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto w-full">
        <div className="p-4 md:p-8 max-w-4xl mx-auto">
          <button
            className="md:hidden mb-4 flex items-center gap-2 text-gray-600 bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-200"
            onClick={() => setIsSidebarOpen(true)}
          >
            <FiMenu /> Danh mục hướng dẫn
          </button>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default GuideLayout;
